var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1749 0.000874306C13.9139 0.0103235 13.6744 0.152058 13.5362 0.378833L6.14177 11.9822L1.35136 7.73644C1.14562 7.51753 0.837007 7.43564 0.55296 7.52698C0.270449 7.61675 0.0601009 7.86242 0.0109684 8.16164C-0.038164 8.46243 0.0800608 8.7648 0.319581 8.9459L5.79785 13.809C5.96981 13.9586 6.19705 14.0247 6.41968 13.9917C6.64385 13.957 6.84191 13.8263 6.96474 13.6326L14.8628 1.26074C15.0317 1.00719 15.0455 0.679626 14.8996 0.411905C14.7538 0.145759 14.4728 -0.0132991 14.1749 0.000874306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.3261a3ed625d4fcd95071a41f020c59e.svg";
export { ForwardRef as ReactComponent };